import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './global/globalBootstrap';
import globalMethods from './global/globalMethods';
import './plugins/element.js'
import {
  getUserToken
} from '@/global/tokenManager';
import {
  userSilentLogin
} from '@/api/api';
import store from './store';

if (localStorage.getItem('shop_login_info')) {
  store.commit('setLoginInfo', JSON.parse(localStorage.getItem('shop_login_info')))
}

Vue.config.productionTip = false
Vue.use(globalMethods);

async function initializeApp() {
  try {
    if (!getUserToken() || !store.state.loginInfo.hasLogin) {
      await userSilentLogin()
    }
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  } catch (error) {
    console.error('游客登录失败:', error);
  }
}

initializeApp()
